<template>
<file-layout @download="onDownload" :file-name="fileName" :show-header="isPublic" :can-download="isPublic" :allow-share="false">
    <!-- <div class="viewbox">
      <img class="image" v-if="link" :src="link" />
    </div> -->
    <previewMedium v-if="!loading" :mediumList="mediumList" ref="previewMedium" class="cloud-preview-medium" @loadSuccess="loadSuccess" :isFileStream="true" :useDefaultLoad="false" @imgPreviewDestory="imgPreviewDestory">
      <template #header="">
        <div class="preview-img-header">
          <div>
            <moo-tooltip class="item" effect="dark" :content="$t('缩小#!!!#src/pages/H5/Cloud/components/ImageView.vue_1')" placement="bottom">
              <img src="@/assets/h5/minus.png" alt="" @click="reduceRadio">
            </moo-tooltip>
          </div>
          <div>
            <moo-tooltip class="item" effect="dark" :content="$t('放大#!!!#src/pages/H5/Cloud/components/ImageView.vue_1')" placement="bottom">
              <img src="@/assets/h5/plus.png" alt="" @click="addRadio">
            </moo-tooltip>
          </div>
          <div>
            <moo-tooltip class="item" effect="dark" :content="$t('1:1显示#!!!#src/pages/H5/Cloud/components/ImageView.vue_1')" placement="bottom">
              <img src="@/assets/h5/oneToOne.png" alt="" @click="oneToOne">
            </moo-tooltip>
          </div>
          <div>
            <moo-tooltip class="item" effect="dark" :content="$t('旋转#!!!#src/pages/H5/Cloud/components/ImageView.vue_1')" placement="bottom">
              <img src="@/assets/h5/rotate.png" alt="" @click="rotate">
            </moo-tooltip>
          </div>
        </div>
      </template>
    </previewMedium>
    <img v-else class="img-loading" src="https://m.elongstatic.com/toca-cloud/product/loading3.gif">
  </file-layout>
</template>

<script>
import { mapState } from "vuex";
import FileLayout from "@/components/h5/Layout";
import { preFetchImg } from "@/api/h5/file";

export default {
  components: {
    FileLayout,
  },
  props: {
    rootId: {
      type: String,
    },
    fileId: {
      type: String,
    },
    metadata: {
      type: Object,
    },
    isPublic: {
      type: Boolean,
    },
    sharePassword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      link: null,
      mediumList: [],
      loading: false,
    };
  },
  watch: {
    fileId: function() {
      this.getLink();
    },
  },
  methods: {
    loadSuccess() {
      this.$emit("loadSuccess");
    },
    imgPreviewDestory() {
      // 图片预览销毁触发
      this.$emit("imgPreviewDestory");
    },
    getLink() {
      const pass = this.sharePassword || "";
      // const inner = `/stream/api/file/preview/other/${this.fileId}`;
      // const outer = `/stream/api/stream/api/public/download/${this.fileId}?rootId=${this.rootId}&password=${pass}&isPreview=true`;
      const inner = `${process.env.VUE_APP_INNERNET_URL}/file/preview/other/${this.fileId}`;
      const outer = `${process.env.VUE_APP_INNERNET_URL}/public/preview/${this.fileId}?rootId=${this.rootId}&password=${pass}&isPreview=true`;
      this.link = this.isPublic ? outer : inner;
      if (!this.isPublic) {
        this.loading = true;
        preFetchImg(this.fileId)
          .then((res) => {})
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
      this.mediumList = [{ type: "img", url: this.link }];
      // return this.isPublic ? outer : inner;
    },

    onDownload() {
      this.$emit("download", this.fileId, false);
    },
    reduceRadio() {
      this.$refs.previewMedium.reduceRadio();
    },
    addRadio() {
      this.$refs.previewMedium.addRadio();
    },
    oneToOne() {
      this.$refs.previewMedium.oneToOne();
    },
    rotate() {
      this.$refs.previewMedium.rotate(-90);
    },
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
    }),

    fileName() {
      return this.metadata ? this.metadata?.fileName : "";
    },
  },
  mounted() {
    this.getLink();
  },
};
</script>

<style lang="scss" scoped>
.viewbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .image {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    border-radius: 4px;
  }
}
</style>

<style lang="scss">
.img-loading {
  width: 100px;
  height: 100px;
}

.cloud-preview-medium {
  .header {
    justify-content: center;

    .preview-img-header {
      padding: 4px 0;
      display: flex;
      column-gap: 32px;
      justify-content: center;
      align-items: center;

      div {
        cursor: pointer;
      }
    }
  }

  .viewer-canvas {
    overflow: hidden !important;
  }

  .content {
    .sk-circle .sk-child::before {
      background-color: #333 !important;
    }
  }

  @media (max-width: 750px) {
    .header {
      display: none !important;
    }

    .viewer-canvas {
      overflow: hidden !important;
    }

    .content {
      padding: 20px 10px !important;
    }
  }
}
</style>
